import { StrictMode } from "react"

import { IDirective } from "angular"
import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"

import { queryClient } from "@/query/queryClient"

import { StudentHelperTeacher } from "./StudentHelperTeacher"
import { StudentHelperTeacherController } from "./StudentHelperTeacher.controller"

export function StudentHelperTeacherReactDirective(): IDirective {
  return {
    restrict: "E",
    require: "^studentHelperTeacher",
    link: function (scope, element, _attributes, controller) {
      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <StudentHelperTeacher
              controller={controller as StudentHelperTeacherController}
            />
          </QueryClientProvider>
        </StrictMode>,
      )

      // Clean up React component when the Angular component is destroyed
      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
  }
}
